import InitApi from "api/InitApi";
import {
	buildFormData,
	hasSelectedFiles,
	isActiveRequested,
	pickBookFiles,
} from "api/BookResource/bookFileUpload";
import ServerErrors from "components/SeverErrors";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import { deleteEmptyObjects } from "utils";
import toast from "react-hot-toast";
import useTokenStore from "store/tokenStore";

const useSubmitBook = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const addBook = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");
		const body = deleteEmptyObjects(obj);
		const wantsActive = isActiveRequested(body.is_active);
		const files = pickBookFiles(body);

		Object.keys(files).forEach((key) => {
			delete body[key];
		});

		const createResponse = await instance.post(
			"/books",
			buildFormData({ ...body, ...files })
		);

		await Promise.all([
			queryClient.invalidateQueries("books"),
			queryClient.invalidateQueries("myUploadedBooks"),
			queryClient.invalidateQueries("tags"),
		]);

		return {
			response: createResponse,
			bookId: createResponse?.data?.data?.id,
			filesProcessing: createResponse?.data?.data?.files_processing,
			hasFiles: hasSelectedFiles(files),
			wantsActive,
		};
	};

	return useMutation(addBook, {
		onSuccess: ({ filesProcessing }) => {
			toast.success(
				filesProcessing
					? "Book created. Files are being processed."
					: "Book created successfully"
			);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{ className: "max-w-max" }
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useSubmitBook;
